import './ChangeCount.scss';
import classNames from 'classnames';
import { getChangeRecordClassName } from '@timeline/@arch/lib';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { Statistic } from 'antd';
import { TimelineChangeType } from '@sonar-software/sonar-core';
import { ArrowDownOutlined, ArrowUpOutlined, SwapOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';

const getChangeRecordIndicator = (changeType: TimelineChangeType): React.ReactNode => {
	switch (changeType) {
	case TimelineChangeType.Discovered:
		return <ArrowUpOutlined />;
	case TimelineChangeType.Modified:
		return <SwapOutlined />;
	case TimelineChangeType.Vanished:
		return <ArrowDownOutlined />;
	default:
		return null;
	}
};

interface ChangeCountProps {
	changeType: TimelineChangeType,
	count?: number;
	highlighted?: boolean;
	filtered?: boolean;
	loading?: boolean;
	objectType: SonarObjectType;
	onClick: (changeType: TimelineChangeType, sonarObjectType: SonarObjectType) => void;
	selected?: boolean;
}

export const ChangeCount: React.FC<ChangeCountProps> = ({
	changeType,
	count,
	highlighted,
	filtered,
	loading,
	objectType,
	onClick,
	selected
}) => {
	const changeClassName = getChangeRecordClassName(changeType, count);
	const indicator = getChangeRecordIndicator(changeType);
	const className = classNames('timeline-change-count clickable', {
		faded: filtered && !selected,
		highlighted,
		selected
	});

	const handleOnClick = useCallback(() => {
		onClick(changeType, objectType);
	}, [ changeType, objectType, onClick ]);

	return (
		<div
			className={ className }
			key={ changeType }
			onClick={ handleOnClick }>
			<Statistic
				className={ changeClassName }
				loading={ Boolean(loading) }
				prefix={ indicator }
				value={ count } />
		</div>
	);
};
